import { Basket, Cart, ColorDescription } from '../../app/types/api-types'
import { DownloadButton, PrintButton, buttonStyle } from '../../controls/buttons';
import { DialogList, DialogListButton, DialogListItem } from '../../controls/dialog-list/dialog-list';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'
import { NOT_READY_YET } from '../../view/debug-info';

import styles from './cart-panel.module.css';

export function CartTop({ name, onNameChanged, messages } : {
    name: string
    messages: Record<string,string>
    onNameChanged: (v:string) => void
}) {
    return <>
        { messages.basket_dialog_title }
        &nbsp;
        <input className={styles.titleInput} type="text" value={name} maxLength={128} onChange={e => onNameChanged(e.target.value)}/>
        <FontAwesomeIcon icon={faPenToSquare} />
    </>
}

export function CartPanel({ cart, totalPrice, totalPriceCurrency, disabled, deletingBaskets, messages, 
                            onAddProduct, onEmptyCart, onPrintCart, onCart3D,
                            onBasketsOverview, onEdit, onRemove, 
                            onQuantityChanged, onSave } : {
    cart: Cart
    totalPrice?: number
    totalPriceCurrency?: string
    disabled: boolean
    deletingBaskets: number[]
    messages: Record<string,string>
    onAddProduct: () => void
    onEmptyCart: () => void
    onPrintCart: () => void
    onCart3D: () => void
    onBasketsOverview: () => void
    onEdit: (basketId: number) => void
    onRemove: (basketId: number) => void
    onQuantityChanged: (basketId: number, quantity: number) => void
    onSave: () => void
}) {    

    return <>
        <DialogList>
            { cart.baskets.map(basket => {
                return <BasketItemView key={basket.shoppingbasketID} basket={basket} disabled={disabled} deleting={deletingBaskets} messages={messages} 
                               onEdit={onEdit} onRemove={onRemove} onQuantityChanged={onQuantityChanged}/>

            })}
        </DialogList>
        { totalPrice !== undefined ?
            <TotalPrice value={totalPrice} currency={totalPriceCurrency ?? ''} messages={messages} />
            :
            null
        }
        
        <div className={styles.cartActions} role="presentation">
            <div role="presentation" className={styles.cartActionsBlock}>
                <button type="button" className={buttonStyle} onClick={onAddProduct}>{messages.basket_add_product}</button>
                <button type="button" className={buttonStyle} onClick={onEmptyCart}>{messages.basket_empty}</button>
                <button type="button" className={buttonStyle} onClick={onSave}>{messages.basket_save}</button>
            </div>
            <div role="presentation" className={styles.cartActionsBlock}>
{/*                 <PrintButton url={cartPDFURL} centered={true}>{messages.basket_print}</PrintButton> */}  
                <button className={buttonStyle} onClick={onPrintCart}>
                    {messages.basket_print}
                </button> 
                <NOT_READY_YET>
                    <button type="button" className={buttonStyle}>{messages.basket_email}</button>
                </NOT_READY_YET>
                <button type="button" className={buttonStyle} onClick={onCart3D}>{messages.basket_3d}</button>
                <button type="button" className={buttonStyle} onClick={onBasketsOverview}>{messages.basket_overview}</button>
            </div>
        </div>
        { /* (MOCK_GET_CART.colordescriptions && MOCK_GET_CART.colordescriptions.length > 0) ?
                <ul className={styles.colorList}>
                {
                    MOCK_GET_CART.colordescriptions.map((cd:ColorDescription) => <ColorDescriptionView key={cd.colorid} color={cd} />)
                }
                </ul>
                :
                null */ }
    </>

}

const QUANTITIES = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ];

const numberFormat = new Intl.NumberFormat('nl', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})

function BasketItemView({ basket, disabled, deleting, messages, onEdit, onRemove, onQuantityChanged } : {
    basket: Basket
    disabled: boolean
    deleting: number[]
    messages: Record<string,string>
    onEdit: (basketId: number) => void
    onRemove: (basketId: number) => void
    onQuantityChanged: (basketId: number, quantity: number) => void
}) {

    const price = Number(basket.price);
    const priceStr = numberFormat.format(price);
    const quantity = Number(basket.quantity);
    const totalPrice = numberFormat.format(price * quantity);
    const isDeleting = deleting.includes(basket.shoppingbasketID);
    return <DialogListItem key={basket.shoppingbasketID} className={styles.articleListItem} deleting={isDeleting}>
        <img src={import.meta.env.VITE_PICTURES_BASE + basket.picture.replace(/^\/wwwserver\/wwwroot/, '')} />
        <div className={styles.artModel}>{basket.modeldescription}</div>
        <ul className={styles.artDescs}>
        {
            basket.lines.map((line,ddIdx) => <li key={ddIdx}>
                <p className={styles.artDDText}>{line.description}</p>
                <p className={styles.artDDCode}>{messages.basket_detail_code.replace('${code}', line.externalcodes)}</p>
            </li>)
        }
        </ul>
        <div className={styles.priceQuantity}>
            <span>{priceStr}&nbsp;{basket.currencycode}</span>
            <div><select onChange={e => onQuantityChanged(basket.shoppingbasketID, Number(e.target.value))} value={quantity}>
            {
                QUANTITIES.map(q => <option key={q} value={q}>{q}</option>)
            }
            </select></div>
            { totalPrice ? <span>{totalPrice}&nbsp;{basket.currencycode}</span>
                                    : null }
            
        </div>
        <div className={styles.articleActions}>
            <DialogListButton type="button" disabled={disabled || isDeleting} onClick={() => onEdit(basket.shoppingbasketID)}>{messages.basket_edit}</DialogListButton>
            <DialogListButton type="button" disabled={disabled || isDeleting} onClick={() => onRemove(basket.shoppingbasketID)}>{messages.basket_remove}</DialogListButton>
        </div>
    </DialogListItem>

}

function TotalPrice({ value, currency, messages }: {
    value: number
    currency: string
    messages: Record<string,string>
}) {

    const valueStr = numberFormat.format(value);
    const price = `${valueStr}\u00a0${currency}`;

    return <div className={styles.totalPrice}>
        { messages.basket_total_price.replace('${price}',price) }
    </div>
}

function ColorDescriptionView({ color }: {
    color: ColorDescription
}) {    
    return <li className={styles.color}>
        <img src={color.colorimage} />
        <div className={styles.colorTitle}>{color.colortitle}</div>
        <div className={styles.colorDesc} dangerouslySetInnerHTML={{__html:color.general}}/>
    </li>
}